module.exports = __webpack_public_path__ + "img/f_ic_finish.5a518e36.svg";